import {
  CollectionPageContents_collection,
  CollectionPageContents_me,
} from 'globalTypes'

import Body from 'Root/App/Body'
import CardWrapper from 'Root/App/Card/Wrapper'

import DefaultStatus from '../../Type/Common/Status/Default'
import styles from './index.module.css'

interface Props {
  collection: CollectionPageContents_collection
  me?: CollectionPageContents_me
  refetch: Function
}

const Page = ({ collection, me, refetch }: Props) => (
  <Body>
    <CardWrapper id={collection.id} className={styles.wrapper}>
      <DefaultStatus collection={collection} me={me} refetch={refetch} />
    </CardWrapper>
  </Body>
)

export default Page
